import React from 'react';
import { Avatar, Box, Typography } from '@mui/material';
import { useParams } from 'react-router';
import { useTiersCtx } from '@europrocurement/l2d-modules/providers/TiersProvider';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { InformationChip, useL2DTheme } from '@europrocurement/flexy-components';
import { dateToFrenchFormat } from '@europrocurement/l2d-utils';
import { useCRMCustomHeader } from '../../providers/CRMCustomHeaderContext';

const CRMPrescriberCustomHeader: React.FunctionComponent = function () {
    const { palette } = useL2DTheme();
    const { id } = useParams();
    const { getTiersById } = useTiersCtx();
    const { offerName } = useCRMCustomHeader();

    const prescripteur = getTiersById(Number(id));
    const codeClient = prescripteur?.codeComptable;

    const lastActivityDate = prescripteur?.dateMAJ ?? prescripteur?.dateCreation;

    const avatarStyle = {
        borderRadius: '8px',
        backgroundColor: palette.icon?.primary?.backgroundColor,
        minHeight: '40px',
        minWidth: '40px',
    };

    const avatarIconStyle = {
        opacity: 1,
        color: palette.primary.main,
        fontSize: '14px',
    };

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
                columnGap: '1em',
            }}
        >
            <Avatar sx={avatarStyle}>
                <FaOptionIcon
                    icon={['fasl', 'buildings']}
                    sx={avatarIconStyle}
                />
            </Avatar>
            <Typography
                variant="l2dh7"
                sx={{ color: palette.secondary.main }}
            >
                {prescripteur?.raisonSociale ?? ''}
            </Typography>
            {codeClient && (
                <Box>
                    <InformationChip
                        label={codeClient}
                        color="primary"
                    />
                </Box>
            )}
            {offerName && (
                <Box>
                    <InformationChip
                        label={offerName}
                        color="warning"
                    />
                </Box>
            )}
            {lastActivityDate && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '6px',
                        opacity: 0.5,
                    }}
                >
                    <FaOptionIcon
                        icon={['fasl', 'clock-rotate-left']}
                        sx={{ fontSize: '12px' }}
                    />
                    <Typography
                        variant="caption"
                        sx={{ textWrap: 'nowrap' }}
                    >
                        {`Dernière activité ${dateToFrenchFormat(lastActivityDate)}`}
                    </Typography>
                </Box>
            )}
        </Box>
    );
};

export default CRMPrescriberCustomHeader;
